/**
 * Hook: Add/Edit and Delete user modal state for Invite Users page.
 * Single Responsibility: open/close and selected user per modal type.
 */

import { useState, useCallback } from 'react';

export function useInviteUsersModals() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const openModal = useCallback((user = null) => {
    setEditingUser(user ?? null);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setEditingUser(null);
  }, []);

  const openDeleteModal = useCallback((user) => {
    setUserToDelete(user);
    setIsDeleteModalOpen(true);
  }, []);

  const closeDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
    setUserToDelete(null);
  }, []);

  return {
    isModalOpen,
    editingUser,
    openModal,
    closeModal,
    isDeleteModalOpen,
    userToDelete,
    openDeleteModal,
    closeDeleteModal,
  };
}
